
import { htmlToText } from '@/tools/index.js'

const toText = function (value) {
    let text = value
    if (value) {
        text = htmlToText(value)
    }
    return text
}
export {
    toText
}